<template>
    <el-form
        :model="form"
        :rules="rules"
        ref="companyForm"
        label-width="140px"
        size="mini">
        <!-- 用户ID -->
        <el-form-item
            :label="$t('message.cdata.form1')">
            <el-input
                :value="form.id"
                class="center-company-form-input"
                disabled>
            </el-input>
        </el-form-item>
        <!-- 公司名称（中文） -->
        <el-form-item
            :label="$t('message.cdata.form2')"
            prop="companyname">
            <el-input
                v-model="form.companyname"
                class="center-company-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 公司名称（英文） -->
        <el-form-item
            :label="$t('message.cdata.form3')"
            prop="en_companyname">
            <el-input
                v-model="form.en_companyname"
                class="center-company-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 电子邮箱 -->
        <el-form-item
            :label="$t('message.cdata.form4')"
            prop="email">
            <el-popover
                placement="right-start"
                trigger="focus">
                <ul class="center-company-email-tips">
                    <li>{{$t("public.emailTips")}}</li>
                </ul>
                <el-input 
                    type="textarea"
                    v-model="form.email"
                    slot="reference"
                    clearable
                    class="center-company-form-input">
                </el-input>
            </el-popover>
            <!-- 更换邮箱 -->
            <!-- <el-button
                type="text"
                @click="getCompanyEmail"
                class="center_company_form_btn">
                <span>{{$t("message.cdata.changeEmail")}}</span>
            </el-button> -->
        </el-form-item>
        <!-- 联系电话 -->
        <el-form-item
            :label="$t('message.cdata.form5')">
            <el-input
                v-model="form.tel"
                class="center-company-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 手机号码 -->
        <el-form-item
            :label="$t('message.cdata.form6')"
            prop="phone">
            <el-input
                v-model="form.phone"
                class="center-company-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 联系地址 -->
        <el-form-item
            :label="$t('message.cdata.form7')"
            prop="address">
            <el-input
                v-model="form.address"
                class="center-company-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 传真号码 -->
        <el-form-item
            :label="$t('message.cdata.form8')">
            <el-input
                v-model="form.fax"
                class="center-company-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 负责人姓名 -->
        <el-form-item
            :label="$t('message.cdata.form9')"
            prop="principal">
            <el-input
                v-model="form.principal"
                class="center-company-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 公司类别 -->
        <el-form-item
            :label="$t('message.cdata.form11')"
            prop="industry">
            <el-select
                v-model="form.industry"
                class="center-company-form-input">
                <el-option
                    v-for="(item, index) in options.industrys"
                    :key="index"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- 市场 -->
        <el-form-item
            :label="$t('message.cdata.form12')"
            prop="market">
            <el-select
                v-model="form.market"
                class="center-company-form-input">
                <el-option
                    v-for="(item, index) in options.markets"
                    :key="index"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- 营业执照
            prop="license" -->
        <el-form-item
            :label="$t('message.cdata.form16')">
            <el-upload
                action="#"
                list-type="picture"
                :show-file-list="false"
                :auto-upload="false"
                :multiple="false"
                :on-change="handleChange"
                class="center-data-company-upload">
                <el-image
                    :src="license_pic"
                    v-if="license_pic"
                    fit="scale-down"
                    lazy
                    class="center-data-company-upload-pic">
                    <!-- 加载中样式 -->
                    <template v-slot:placeholder>
                        <div class="image-slot">
                            <i class="el-icon-loading"></i>
                        </div>
                    </template>
                    <!-- 加载失败样式 -->
                    <template v-slot:error>
                        <div class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </template>
                </el-image>
                <i v-else slot="default" class="el-icon-plus center-data-company-upload-icon"></i>
            </el-upload>
        </el-form-item>
        <!-- 金额分配总额度 -->
        <el-form-item
            :label="$t('message.cdata.form10')">
            <el-input
                v-model="form.amount"
                class="center-company-form-input"
                clearable>
            </el-input>
        </el-form-item>
        <!-- 提交行 -->
        <el-form-item>
            <el-button
                type="primary"
                @click="submitModify(form)">
                <span>{{$t("public.submitBtn")}}</span>
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import region from '@/utils/region';
import { email } from "@/utils/validate";

export default {
    data() {
        let validateEmail = (rule, value, callback) => {
            email(this, true, value, callback);
        };
        return {
            // 营业执照
            license_pic: "",
            form: {
                id: "",
                companyname: "",
                en_companyname: "",
                email: "",
                tel: "",
                phone: "",
                address: "",
                fax: "",
                principal: "",
                area: "",
                industry: "",
                market: "",
                license: "",
                amount: "",
            },
            rules: {
                companyname: [
                    { required: true, message: this.$t("message.cdata.rule1"), trigger: 'blur' }
                ],
                en_companyname: [
                    { required: true, message: this.$t("message.cdata.rule2"), trigger: 'blur' }
                ],
                email: [
                    { required: true, validator: validateEmail, trigger: ['blur', 'change'] }
                ],
                tel: [
                    { required: true, message: this.$t("message.cdata.rule4"), trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: this.$t("message.cdata.rule5"), trigger: 'blur' }
                ],
                address: [
                    { required: true, message: this.$t("message.cdata.rule6"), trigger: 'blur' }
                ],
                fax: [
                    { required: true, message: this.$t("message.cdata.rule7"), trigger: 'blur' }
                ],
                principal: [
                    { required: true, message: this.$t("message.cdata.rule8"), trigger: 'blur' }
                ],
                industry: [
                    { required: true, message: this.$t("message.cdata.rule10"), trigger: 'blur' }
                ],
                market: [
                    { required: true, message: this.$t("message.cdata.rule11"), trigger: 'blur' }
                ],
            }
        }
    },
    computed: mapState({
        user_data: state => state.user.user_data,
        options(){
            let lang = localStorage.lang,
            industrys = region.cn_type,
            markets = region.cn_regions;
            if(lang == "en"){
                industrys = region.en_type;
                markets = region.en_regions;
            }
            return {
                industrys,
                markets
            }
        }
    }),
    methods: {
        ...mapActions([
            "getCompanyData",
            "handleModifyCompany",
            "getCompanyEmail"
        ]),
        setForm(val){ // 写入表单参数
            this.form = {
                id: val.user_id,
                companyname: val.companyname,
                en_companyname: val.en_companyname,
                email: val.email,
                tel: val.tel,
                phone: val.phone,
                address: val.address,
                fax: val.fax,
                principal: val.principal,
                area: val.area,
                industry: val.industry,
                market: val.market,
                license: val.license,
                amount: val.amount
            }
            this.license_pic = val.license;
        },
        handleChange(file, fileList){ // 营业执照base64编码写入
            let reader = new FileReader();
            reader.onload = () => {
                let _base64 = reader.result;
                let BASE64 = _base64.split(",");
                this.form.license = BASE64[1];
                this.license_pic = file.url;
            }
            reader.readAsDataURL(file.raw)
        },
        submitModify(form){ // 提交修改
            this.$refs.companyForm.validate((valid) => {
                if(valid) {
                    this.handleModifyCompany({
                        company_id: this.user_data.company_id,
                        companyname: form.companyname,
                        en_companyname: form.en_companyname,
                        email: form.email,
                        tel: form.tel,
                        phone: form.phone,
                        principal: form.principal,
                        address: form.address,
                        fax: form.fax,
                        area: form.area,
                        industry: form.industry,
                        market: form.market,
                        license: form.license,
                        amount: form.amount
                    }).then((res) => {
                        if(res.type){
                            this.$message({
                                showClose: true,
                                message: this.$t("public.modifySucc"),
                                type: "success"
                            })
                            setTimeout(() => {
                                this.getCompanyData();
                            }, 1000);
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: "error"
                            })
                        }
                    })
                }else{
                    return false;
                }
            })
        }
    },
    created() {
        this.setForm(this.user_data);
    },
    watch: {
        user_data(val){
            this.setForm(val);
        }
    },
}
</script>

<style scoped>
.center-company-form-input{
    width: 230px;
}
.center-company-email-tips{
    list-style-type: circle;
    padding-left: 20px;
    color: #909399;
}
/* 营业执照 */
.center-data-company-upload>>>.el-upload{
    width: 178px;
    height: 178px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.center-data-company-upload>>>.el-upload:hover {
    border-color: #409EFF;
}
.center-data-company-upload-pic{
    width: 100%;
    height: 100%;
}
.image-slot,
.center-data-company-upload-icon{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-size: 28px;
    color: #8c939d;
}
</style>
